import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/i18n";
import { Reveal } from "@/components/Reveal";

export function BlogCard({ post, index = 0 }) {
  const { t, lang } = useLang();
  const title = lang === "hi" && post.title_hi ? post.title_hi : post.title;
  const excerpt = lang === "hi" && post.excerpt_hi ? post.excerpt_hi : post.excerpt;
  const catLabel = t("cats")[post.category] ?? post.category;

  return (
    <Reveal delay={Math.min(index * 0.07, 0.35)} className="blog-card-reveal">
      <article className="blog-card" data-testid={`blog-post-${post.id}`}>
        <div className="blog-card-top">
          <Link className="chip" to={`/blog?cat=${encodeURIComponent(post.category)}`} data-testid={`blog-cat-${post.id}`}>{catLabel}</Link>
          <span className="blog-date">{post.date}</span>
        </div>
        <h3>
          <Link to={`/blog/${post.id}`} data-testid={`blog-title-link-${post.id}`}>{title}</Link>
        </h3>
        <p>{excerpt}</p>
        <div className="blog-card-foot">
          <span>{post.read_minutes || 4} {t("blog.min")}</span>
          <Link to={`/blog/${post.id}`} className="read-link" data-testid={`read-blog-${post.id}`}>
            {t("insights.read")} <ArrowUpRight size={15} />
          </Link>
        </div>
      </article>
    </Reveal>
  );
}
